import { Injectable } from '@angular/core';

export enum ConsentType {
    Withdrawn,
    Allow,
    Deny,
    Selected,
}

export interface IConsentConfig {
    necessary: boolean;
    preferences: boolean;
    statistics: boolean;
    marketing: boolean;
}

export interface IConsent {
    type: ConsentType;
    scopes: string[];
}

@Injectable({
    providedIn: 'root',
})
export class CookieConsentService {
    private _scopes: string[] = [];

    getConsent(consent: IConsentConfig): IConsent {
        const res: IConsent = this._getConsent(consent);
        this._scopes = res.scopes;

        return res;
    }

    private _getConsent(consent: IConsentConfig): IConsent {
        const newScopes: string[] = Object.keys(consent).filter(
            (x: string) => consent[x as keyof IConsentConfig]
        );

        const allow = newScopes.length === Object.keys(consent).length;
        if (allow) {
            return { type: ConsentType.Allow, scopes: newScopes };
        } else if (this._scopes.length > 1 && newScopes.length === 1) {
            return { type: ConsentType.Withdrawn, scopes: newScopes };
        } else if (!this._scopes.length && newScopes.length === 1) {
            return { type: ConsentType.Deny, scopes: newScopes };
        } else {
            return { type: ConsentType.Selected, scopes: newScopes };
        }
    }
}
